
export enum PreviewContentType {
    IFRAME = 'IFRAME',
    TEXT = 'TEXT'
}